import { format } from 'date-fns';
import type { TimeBlock as TimeBlockType } from '../types';
import { useState } from 'react';
import { HOUR_HEIGHT } from '../../../constants/calendar';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

interface TimeBlockProps {
  block: TimeBlockType;
  isFocused: boolean;
  isInBackground: boolean;
  isEditing: boolean;
  onTitleChange: (block: TimeBlockType, title: string) => void;
  onTitleBlur: () => void;
  onFocusClick: (e: React.MouseEvent, block: TimeBlockType) => void;
  onEditClick: (e: React.MouseEvent, block: TimeBlockType) => void;
  onDeleteClick?: (block: TimeBlockType) => void;
}

export const TimeBlock = ({
  block,
  isFocused,
  isInBackground,
  isEditing,
  onTitleChange,
  onTitleBlur,
  onFocusClick,
  onEditClick,
  onDeleteClick,
}: TimeBlockProps) => {
  console.log(block, 'isInBackground', isInBackground);
  const [isTitleEditing, setIsTitleEditing] = useState(false);
  const startHour =
    block.startTime.getHours() + block.startTime.getMinutes() / 60;
  const endHour = block.endTime.getHours() + block.endTime.getMinutes() / 60;
  const duration = endHour - startHour;

  console.log(startHour, 'startHour');
  const showButtonsAbove = startHour > 0.5;

  const handleTitleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onFocusClick(e, block);
    setIsTitleEditing(true);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onTitleChange(block, e.target.value);
  };

  const handleTitleBlur = () => {
    setIsTitleEditing(false);
    onTitleBlur();
  };

  const handleBlockClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onFocusClick(e, block);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDeleteClick?.(block);
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    console.log('editing block', block);
    onEditClick(e, block);
  };

  return (
    <div
      data-block-id={block.id}
      className={clsx(
        'absolute w-full border rounded p-0.5 time-block cursor-pointer',
        (isFocused || isEditing) && 'border-blue-500',
        isInBackground && 'bg-gray-100 border-black-300',
        !isInBackground && 'bg-blue-100 border-blue-300',
      )}
      style={{
        top: `${startHour * HOUR_HEIGHT}px`,
        height: `${duration * HOUR_HEIGHT}px`,
      }}
      onClick={handleBlockClick}
    >
      {isFocused && (
        <div
          className={`absolute left-0 right-0 flex justify-end gap-2 px-0 py-0 pointer-events-none ${
            showButtonsAbove ? '-top-10' : '-bottom-10'
          } z-10`}
        >
          <button
            onClick={handleEdit}
            className="pointer-events-auto bg-blue-200 rounded-full p-1.5 shadow transition-colors flex items-center justify-center"
            title="Edit"
            aria-label="Edit"
            type="button"
          >
            <PencilSquareIcon className="w-5 h-5 text-gray-700" />
          </button>
          <button
            onClick={handleDelete}
            className="pointer-events-auto bg-blue-200 rounded-full p-1.5 shadow transition-colors flex items-center justify-center"
            title="Delete"
            aria-label="Delete"
            type="button"
          >
            <TrashIcon className="w-5 h-5 text-gray-700" />
          </button>
        </div>
      )}
      <div className="flex justify-between items-start h-full overflow-hidden">
        <div className="flex-1">
          {isTitleEditing ? (
            <input
              type="text"
              value={block.title}
              onChange={handleTitleChange}
              onBlur={handleTitleBlur}
              className="w-full bg-transparent border-none focus:outline-none text-xs leading-[16px] p-0 m-0 h-[16px] block"
              style={{ lineHeight: '16px' }}
              autoFocus
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleTitleBlur();
                }
              }}
            />
          ) : (
            <div
              className="text-xs cursor-text hover:bg-blue-200 px-1 -mx-1"
              onClick={handleTitleClick}
            >
              {block.title}
            </div>
          )}
          <div className="text-xs text-gray-600 truncate">
            {format(block.startTime, 'HH:mm')} -{' '}
            {format(block.endTime, 'HH:mm')}
          </div>
        </div>
      </div>
    </div>
  );
};
